/* eslint-disable no-unused-vars */

export enum GeneralErrorType {
  PROFILE_UNAVAILABLE = 'PROFILE_UNAVAILABLE',
  PROFILE_INCOMPLETE = 'PROFILE_INCOMPLETE',
  DEFAULT = 'DEFAULT',
  NONE = '',
}

export default GeneralErrorType;
